module.exports = __webpack_public_path__ + "static/media/one-flavor-pizza.a60266b3.svg";